import { openWidget } from 'actions/main';
import { initIntentConversation } from 'actions/workflows-v2/workflowsV2';
import {
  setSelectedIntentIndex,
  setStepSent,
} from 'actions/workflows/workflows';
import type { InitIntentInterface } from 'api/types';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { selectIsPrivacyConsented } from 'reducers/config';
import {
  selectWorkflowsConfig,
  selectWidgetComponents,
  setActionToExecAfterPrivacyConsented,
  privacyConsented,
} from 'reducers/workflows';

export const useHandlePromptIntentOptionClicked = ({
  triggerFromPrivacyConsent = false,
}: {
  triggerFromPrivacyConsent?: boolean;
} = {}) => {
  const dispatch = useAppDispatch();
  const workflowsConfig = useAppSelector(selectWorkflowsConfig);
  const widgetComponents = useAppSelector(selectWidgetComponents);
  const isPrivacyConsented = useAppSelector(selectIsPrivacyConsented);

  const handleClicked = useCallback(
    (selectedIntentIndex: number) => {
      dispatch(setSelectedIntentIndex(selectedIntentIndex));

      if (!isPrivacyConsented && !triggerFromPrivacyConsent) {
        dispatch(setActionToExecAfterPrivacyConsented('intentOptionClicked'));
        dispatch(openWidget());
        return;
      }

      const intents = workflowsConfig?.top_n_intents || [];
      const selectedIntent = intents[selectedIntentIndex];

      if (selectedIntent !== undefined) {
        const intent: InitIntentInterface = {
          intent_id: selectedIntent.intent_id,
        };

        dispatch(
          setStepSent({
            query: intent.intent_name,
            stepIndex: 0,
          }),
        );
        dispatch(openWidget());
        dispatch(
          initIntentConversation({
            intent,
            isProactive: true,
          }),
        );

        if (widgetComponents.length > 0) {
          dispatch(setStepSent({ stepIndex: widgetComponents.length - 1 }));
        }
      }

      if (triggerFromPrivacyConsent) {
        dispatch(privacyConsented());
      }
    },
    [
      dispatch,
      widgetComponents.length,
      workflowsConfig?.top_n_intents,
      isPrivacyConsented,
      triggerFromPrivacyConsent,
    ],
  );

  return handleClicked;
};
